function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var Subscription = /*#__PURE__*/function () {
  function Subscription(id) {
    _classCallCheck(this, Subscription);

    this.id = id;
    this.intent = 'unsubscribed';
    this.state = 'idle';
    this.channels = [];
    this.disposed = false;
    this._pendings = [];
  }

  _createClass(Subscription, [{
    key: "add",
    value: function add(channel) {
      if (this.channels.includes(channel)) return;
      this.channels.push(channel);
    }
  }, {
    key: "remove",
    value: function remove(channel) {
      var ind = this.channels.indexOf(channel);
      if (ind > -1) this.channels.splice(ind, 1);
    }
  }, {
    key: "notify",
    value: function notify(state) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.state = state;

      if (args.length === 1) {
        this.channels.forEach(function (channel) {
          return channel[state](args[0]);
        });
      } else {
        this.channels.forEach(function (channel) {
          return channel[state]();
        });
      }
    }
  }, {
    key: "pending",
    value: function pending(intent) {
      this._checkIntent(intent);

      var nextPending = this._pendings[0];
      if (!nextPending || nextPending.intent !== intent) return Promise.resolve();
      return nextPending.promise;
    }
  }, {
    key: "ensureResubscribed",
    value: function ensureResubscribed() {
      if (this.disposed) return;
      this.intent = undefined;
      this.ensureSubscribed();
    }
  }, {
    key: "ensureSubscribed",
    value: function ensureSubscribed() {
      if (this.intent === 'subscribed') return;
      if (this.disposed) throw Error('Subscription is disposed');
      this.intent = 'subscribed';

      var merged = this._mergeWithPending('unsubscribed');

      if (merged) return;
      this.subscriber(this);
    }
  }, {
    key: "maybeUnsubscribe",
    value: function maybeUnsubscribe() {
      if (this.disposed) return;
      if (this.intent === 'unsubscribed') return;
      if (this.channels.length > 0) return;
      this.intent = 'unsubscribed';

      var merged = this._mergeWithPending('subscribed');

      if (merged) return;
      this.unsubscriber(this);
    }
  }, {
    key: "acquire",
    value: function () {
      var _acquire = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(intent) {
        var _this = this;

        var resolver, promise, lock, top;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._checkIntent(intent);

                promise = new Promise(function (resolve) {
                  resolver = resolve;
                });
                lock = {
                  promise: promise,
                  intent: intent,
                  release: function release() {
                    _this._pendings.splice(_this._pendings.indexOf(lock), 1);

                    resolver(lock);
                  },
                  canceled: false,
                  acquired: false
                };
                top = this._pendingTop;

                this._pendings.push(lock);

                if (!top) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return top.promise;

              case 8:
                lock.acquired = true;
                return _context.abrupt("return", lock);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function acquire(_x) {
        return _acquire.apply(this, arguments);
      }

      return acquire;
    }()
  }, {
    key: "close",
    value: function close(err) {
      this.disposed = true;
      this.intent = undefined;
      this.notify('closed', err);
    }
  }, {
    key: "_checkIntent",
    value: function _checkIntent(event) {
      if (event === 'unsubscribed' || event === 'subscribed') return;
      throw Error("Unknown subscription intent: ".concat(event));
    }
  }, {
    key: "_pendingTop",
    get: function get() {
      return this._pendings.length ? this._pendings[this._pendings.length - 1] : undefined;
    }
  }, {
    key: "_mergeWithPending",
    value: function _mergeWithPending(intent) {
      var top = this._pendingTop;
      if (!top) return false;
      if (top.acquired) return false;
      if (top.intent !== intent) return false;

      this._pendings.pop();

      top.canceled = true;
      return true;
    }
  }]);

  return Subscription;
}();
export var Subscriptions = /*#__PURE__*/function () {
  function Subscriptions() {
    _classCallCheck(this, Subscriptions);

    this._subscriptions = {};
    this._localToRemote = {};
  }

  _createClass(Subscriptions, [{
    key: "all",
    value: function all() {
      return Object.values(this._subscriptions);
    }
  }, {
    key: "get",
    value: function get(id) {
      return this._subscriptions[id];
    }
  }, {
    key: "create",
    value: function create(id, _ref) {
      var subscribe = _ref.subscribe,
          unsubscribe = _ref.unsubscribe;
      var sub = this._subscriptions[id] = new Subscription(id);
      sub.remoteId = this._localToRemote[id];
      sub.subscriber = subscribe;
      sub.unsubscriber = unsubscribe;
      return sub;
    }
  }, {
    key: "remove",
    value: function remove(id) {
      delete this._subscriptions[id];
      delete this._localToRemote[id];
    }
  }, {
    key: "storeRemoteId",
    value: function storeRemoteId(localId, remoteId) {
      this._localToRemote[localId] = remoteId;
      var sub = this.get(localId);
      if (sub) sub.remoteId = remoteId;
    }
  }]);

  return Subscriptions;
}();
export var Hub = /*#__PURE__*/function () {
  function Hub() {
    _classCallCheck(this, Hub);

    this.subscriptions = new Subscriptions();
    this._pendingMessages = [];
    this._remoteToLocal = {};
  }

  _createClass(Hub, [{
    key: "subscribe",
    value: function subscribe(localId, remoteId) {
      this._remoteToLocal[remoteId] = localId;
      this.subscriptions.storeRemoteId(localId, remoteId);
      this.flush(remoteId);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(localId) {
      var sub = this.subscriptions.get(localId);
      if (!sub) return;
      var remoteId = sub.remoteId;
      if (remoteId) delete this._remoteToLocal[remoteId];
      this.subscriptions.remove(localId);
    }
  }, {
    key: "transmit",
    value: function transmit(id, msg, meta) {
      var localId = this._remoteToLocal[id];

      if (!localId) {
        this._pendingMessages.push([id, msg, meta]);

        return;
      }

      var sub = this.subscriptions.get(localId);
      if (!sub) return;
      sub.channels.forEach(function (channel) {
        channel.receive(msg, meta);
      });
    }
  }, {
    key: "close",
    value: function close() {
      this._pendingMessages.length = 0;
    }
  }, {
    key: "size",
    get: function get() {
      return this.channels.length;
    }
  }, {
    key: "channels",
    get: function get() {
      return this.subscriptions.all().flatMap(function (sub) {
        return sub.channels;
      });
    }
  }, {
    key: "flush",
    value: function flush(id) {
      var left = [];

      var _iterator = _createForOfIteratorHelper(this._pendingMessages),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item[0] === id) this.transmit(item[0], item[1], item[2]);else left.push(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._pendingMessages = left;
    }
  }]);

  return Hub;
}();